import $ from 'jquery'

$(document).ready(dhsv_vc_googlemap())

function dhsv_vc_googlemap() {}
